type AuthFailureReason = 'sse_auth_expired' | '403_unrecoverable' | 'persistent_401' | string;

const _bus = new EventTarget();
const _wrappers = new Map<Function, EventListener>();

export function emitAuthFailure(reason: AuthFailureReason): void {
  _bus.dispatchEvent(new CustomEvent('auth:failure', { detail: { reason } }));
}

export function onAuthFailure(callback: (reason: AuthFailureReason) => void): void {
  const wrapper: EventListener = (e) => callback((e as CustomEvent).detail.reason);
  _wrappers.set(callback, wrapper);
  _bus.addEventListener('auth:failure', wrapper);
}

export function offAuthFailure(callback: (reason: AuthFailureReason) => void): void {
  const wrapper = _wrappers.get(callback);
  if (wrapper) {
    _bus.removeEventListener('auth:failure', wrapper);
    _wrappers.delete(callback);
  }
}
